import React from 'react';
import { Button } from './ui/button';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = ({ company }) => {
  const handleCall = () => {
    window.location.href = `tel:${company.phone.replace(/[^0-9+]/g, '')}`;
  };

  const handleEmail = () => {
    window.location.href = `mailto:${company.email}`;
  };

  return (
    <footer id="contacts" className="footer-section">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-col">
            <h3 className="footer-heading">{company.name}</h3>
          </div>

          <div className="footer-col">
            <div className="footer-info-item">
              <MapPin size={20} className="footer-icon" />
              <div>
                <p className="footer-label">Адреса</p>
                <p>{company.address}</p>
              </div>
            </div>
          </div>

          <div className="footer-col">
            <div className="footer-info-item">
              <Phone size={20} className="footer-icon" />
              <div>
                <p className="footer-label">Телефон</p>
                <a href={`tel:${company.phone.replace(/[^0-9+]/g, '')}`} className="footer-link">
                  {company.phone}
                </a>
              </div>
            </div>
            
            <div className="footer-info-item">
              <Mail size={20} className="footer-icon" />
              <div>
                <p className="footer-label">Email</p>
                <a href={`mailto:${company.email}`} className="footer-link">
                  {company.email}
                </a>
              </div>
            </div>
          </div>

          <div className="footer-col">
            <div className="footer-info-item">
              <Clock size={20} className="footer-icon" />
              <div>
                <p className="footer-label">Години роботи</p>
                <p>{company.workingHours}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-actions">
          <Button onClick={handleCall} className="btn-primary">
            Зателефонувати
          </Button>
          <Button onClick={handleEmail} className="btn-secondary">
            Написати
          </Button>
        </div>

        <div className="footer-bottom">
          <p>© 2025 {company.name}. Всі права захищені.</p>
          <Link to="/privacy" className="footer-privacy-link">
            Політика конфіденційності
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
